import { createContext, useContext, useState } from 'react'
import { ChannelsListContextValue, ChannelsListProviderProps } from './ChannelsListContextTypes'
import { ChannelOption } from 'components/Wizards/CampaignWizard/Types'
import { useField } from 'formik'

const ChannelsListContext = createContext<ChannelsListContextValue>({
  setEditingChannelType: () => {},
  removeChannelType: () => {},
  updateChannels: () => {},
})

const ChannelsListContextProvider = ChannelsListContext.Provider

export const ChannelsListProvider = ({ children }: ChannelsListProviderProps) => {
  const [channelsField, , { setValue: setChannels }] = useField('channels')
  const [editingChannelType, setEditingChannelType] = useState<ChannelOption['channel_type']>()

  const channels = channelsField.value as ChannelOption[]

  const value = {
    editingChannelType,
    setEditingChannelType,
    removeChannelType: (channelType: ChannelOption['channel_type']) => {
      setChannels(channels.filter((channel) => channel.channel_type !== channelType))
    },
    updateChannels: (updatedChannels: ChannelOption[]) => {
      setChannels(
        channels.map((c) => {
          const updatedChannel = updatedChannels.find(
            (uc) => uc.channel_type === c.channel_type && uc.width === c.width && uc.height === c.height,
          )
          return updatedChannel ? { ...c, ...updatedChannel } : c
        }),
      )
    },
  }

  return <ChannelsListContextProvider value={value}>{children}</ChannelsListContextProvider>
}

export const useChannelsListContext = () => {
  return useContext(ChannelsListContext)
}
